// import './App.css';
import { useEffect, useState } from "react";
import {
  FormControl,
  TextField,
  Button,
  Switch,
  FormControlLabel,
  Select,
  MenuItem,
  InputLabel,
} from "@material-ui/core";
import LoadingOverlay from "react-loading-overlay";
import { default as ReactSelect } from "react-select";

import { getReports } from "../services/api";

const classes = {};

function ReportSelector({ value, setValue }) {
  const [loading, setLoading] = useState(false);
  const [reports, setReports] = useState([]);

  useEffect(() => {
    getReports().then((res) => {
      setReports(res);
    })
  }, []);

  const handleChange = (event) => {
    setValue(event.value);
  };

  let selectedLabel = "";
  let report = reports.find((r) => r.id === value);
  if(report) selectedLabel = report.name;

  return (
    <LoadingOverlay active={loading} spinner>
      {/* <span id="demo-simple-select-label">Target</span> */}
      <FormControl className="inputForms">
        <p className="labelNew">Report category</p>
        <ReactSelect
          value={{
            value: value,
            label: selectedLabel,
          }}
          options={reports.map((r) => ({
            value: r.id,
            label: r.name
          }))}
          onChange={handleChange}
        />
      </FormControl>
    </LoadingOverlay>
  );
}

export default ReportSelector;
